export const CSV_UPLOAD_ERROR_BANNER_LABELS = {
	TITLE: 'Your file has errors',
	BODY: "Your file couldn't be uploaded. Download the annotated file, fix the errors, then upload it again.",
	DOWNLOAD_BUTTON: 'Download Annotated File',
	DISMISS_ARIA: 'Dismiss error',
	SECTION_ARIA: 'Label values CSV upload error'
} as const;
